module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"until":"до","allVacanciesArchived":"Все вакансии из этой подборки перешли в архив","emptyVacancies":"В этой подборке нет вакансий","filterTitle":"Подборка вакансий","filter.all":"Все вакансии","filter.address":"Вакансии по адресу","filter.list":"Выбрать вручную","allVacancies":"Все вакансии"}}')
  delete Component.options._Ctor
}
